export default {
  common: {
    send: "Send",
    submit: "Submit",
    cancel: "Cancel",
    confirm: "OK",
    login: "Login",
    logout: "Logout",
    logoutAccount: "Log out",
    upload: "Upload",
    newChat: "New Chat",
    conversation: "Chat",
  },
  chat: {
    viewMoreAnswer: "View a more detailed answer:",
    sourceFrom: "Source:",
    stopOutput: "Stop",
    excelPrefix: "Glad to serve you. Please ",
    excelSuffix: " your Excel file!",
    componentKnowledge: "Component Knowledge Base",
    initLoading: "Initializing, please wait...",
    generateForm: "Generate Form",
    openVip: "Become a Member",
    welcome:
      "Hello, I'm DianXiaoXiao. By chatting with me, you can quickly access knowledge about the electrical assembly industry, learn about component parameters and prices, find replacement components, and let me recommend BOM information for complete equipment. We look forward to your experience and feedback.",
    tab: {
      selection: "Selection & Ordering",
      usage: "Operating Conditions",
      transport: "Transport & Storage",
      tech: "Technical Parameters",
      dimension: "Dimensions & Installation",
    },
    device: {
      purpose: "Please select the intended use to query",
      model: "Please select the product model to query",
      size: "Please select the cabinet W*H*D to query",
      switchType: "Please select the main switch type to query",
      installType: "Please select the main switch mounting type to query",
      current: "Please select the main switch current to query",
      breaking: "Please select the main switch breaking capacity to query",
      brand: "Please select the main switch brand to query",
      summary:
        "Summary of the cabinet you selected:\n\nUse: {name}\nProduct model: {model}\nCabinet W*H*D: {size}\nMain switch type: {typesof}\nMain switch mounting: {install}\nMain switch current: {electric}\nMain switch breaking capacity: {segmenting}\nMain switch brand: {brand}",
    },
    title: {
      tryAsk: "You can try asking:",
      canGenerateForm: "You can generate a form to ask questions",
      satisfied: "Are you satisfied with this answer? You can continue by generating a form to ask",
      freeUsedUp: "You have used up today's free Q&A quota. Become a member to enjoy unlimited Q&A",
      moreRelated: "Found more related Q&A for you, click to try:",
    },
    status: {
      thinking: "Thinking...",
      stopped: "Output stopped",
    },
    action: {
      copy: "Copy",
      regenerate: "Regenerate",
      like: "Like",
      dislike: "Dislike",
      downloadTable: "Download as Table",
    },
  },
  home: {
    dtx: "DianTianXia",
    subscribe: "Subscription",
    uploading: "Uploading",
    uploadImage: "Upload image",
    holdToSpeak: "Hold to speak",
    listening: "Listening, please speak...",
    listeningShort: "Listening...",
    inputPlaceholder: "Type a message or image / Hold the mic on the right to speak…",
    releaseToSend: "Release to send to the input box",
  },
  login: {
    slogan: "A quality electrical data sharing community: professional, substantial and fun",
    tabPersonal: "Personal",
    tabEnterprise: "Enterprise",
    phoneOrEmail: "Mobile / Email",
    phone: "Mobile number",
    phoneShort: "Mobile",
    password: "Password",
    verifyCode: "Verification code",
    getVerifyCode: "Get code",
    imageCode: "Image code",
    switchToPhoneLogin: "Login with SMS code",
    switchToAccountLogin: "Login with account",
    enterpriseAccount: "Enterprise account",
    agreement: "By registering / logging in, you agree to",
    privacy: " the DianTianXia Privacy Statement ",
  },
  loginView: {
    title: "Login",
    usernamePlaceholder: "Username",
    passwordPlaceholder: "Password",
    forgetPassword: "Forgot password",
    forgetTitle: "Forgot password",
    account: "Account",
    accountPlaceholder: "Please enter your account",
    password: "Password",
    // passwordPlaceholder: "Please enter your password",
    confirmPassword: "Confirm password",
    confirmPasswordPlaceholder: "Please confirm your password",
  },
  userLogin: {
    title: "DianXiaoXiao AI Assistant",
    pleaseLogin: "Please log in",
  },
  channelDialog: {
    tip: "Tip: ask under the correct category so DianXiaoXiao can answer more accurately",
  },
  userAdvance: {
    question: "Did this service solve your problem?",
    resolved: "Resolved",
    unresolved: "Unresolved",
    suggestionPlaceholder: "Any other comments or suggestions?",
  },
  vierPicture: {
    close: "Close",
    export: "Export",
  },
  produceInfo: {
    currentProduct: "Current Product Services",
    intro: "Product Intro",
    resourcePurchase: "Resource Purchase",
    community: "Community",
    cloudClass: "Cloud Class",
    scanFollow: "Scan to follow more Leadre updates",
    leadreNews: "Leadre Updates",
  },
  mobileNav: {
    title: "DianXiaoXiao - Electrical AI Assistant",
  },
  recommended: {
    title: "Popular Activities",
  },
  elementCard: {
    views: "Views:",
    favorites: "Favorites:",
  },
  errorPage: {
    back: "Back",
    gifSource: "gif source",
    page: "page",
    noPermission: "You don't have permission to access this page",
    contactLeader: "If you have any complaints, please contact your supervisor",
    orYouCan: "Or you can go to:",
    backHome: "Back to Home",
    lookAround: "Look around",
    clickToSee: "Click to see image",
    randomTitle: "Random view",
    dtx: "DianTianXia",
  },
  empty: {
    title: "Admin Home",
    serverInfo: "Server Info",
  },
};
